import React from "react";

const Home = ({ className }) => (
  <svg
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.79293 3.55878C0.857289 4.10864 0.300049 5.00718 0.300049 5.96603V12.6C0.300049 13.7046 1.19548 14.6 2.30005 14.6H4.43338C4.98567 14.6 5.43338 14.1523 5.43338 13.6V8.79904H10.5669V13.6C10.5669 14.1523 11.0146 14.6 11.5669 14.6H13.7002C14.8048 14.6 15.7002 13.7046 15.7002 12.6V5.96602L15.7001 5.96603C15.7001 5.00718 15.1428 4.10864 14.2072 3.55878L9.20432 0.618691C8.48125 0.193754 7.51885 0.193753 6.79578 0.618691L1.79293 3.55878Z"
    />
  </svg>
);

export default Home;
